import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Prison: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath d="M6 5v14M10 5v14M14 5v14M18 5v14" {...pathProps} />
        </IconSVG>
    );
};
